import React from 'react';
import { Button, Gutter, IconButton, Layout, LayoutItem } from '@axiom/ui';
import type { Candidate, User } from '@axiom/validation';

import { AxiomForTalentUtil } from '../../utils/axiom-for-talent-util';

// Named export to match filename
export const BenchViewGridActionsUtil = {};

type ActionsCellProps = {
  data: Candidate;
  user: User;
};

export const actionsCell = ({ data, user }: ActionsCellProps) => {
  return (
    <Layout name="ACTIONS_CELL" position="center middle" horizontalGutter="8px">
      <LayoutItem borderRight="1px solid contentBreak" position="center">
        <Gutter right="16px" as="span">
          <IconButton
            name="POP_OUT_BUTTON"
            icon="pop-out"
            pattern="secondary"
            variation="minimal"
            toTab={`/talent-detail/${data.id}`}
            title={`Open "${data.calculatedDisplayName}" in new tab`}
          />
        </Gutter>
      </LayoutItem>
      {AxiomForTalentUtil.canViewAft(data, user) && (
        <LayoutItem>
          <Button
            name="AFT_BUTTON"
            pattern="secondary"
            variation="minimal"
            onClick={() => {
              AxiomForTalentUtil.openAftProfile(data.id);
            }}
            title={`Open A.F.T profile for "${data.calculatedDisplayName}"`}
          >
            A.F.T
          </Button>
        </LayoutItem>
      )}
    </Layout>
  );
};
